import { gql } from '@apollo/client/core';

export const ADVENTURE_METADATA_QUERY = gql`
  query ($id: Int) {
    allCategories: adventureMetaData {
      categories {
        name
        id
      }
    }
    adventureMetaData(id: $id) {
      categories {
        id
        name
        adventureCategoryImages {
          adventureCategoryId
          id
          label
          url
        }
        ageRanges {
          id
          optionText
          maxRange
          minRange
        }
        descriptionExample
        passionExample
        suppliesExample
        titleExample
      }
      constraints {
        field
        max
        min
      }
    }
  }
`;

export const SITTER_ADVENTURES_QUERY = gql`
  query ($status: [AdventureStatus!]) {
    sitterAdventures(status: $status) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          adventure {
            id
            adventureCategoryId
            adventureCategoryImage {
              id
              url
              label
              adventureCategoryId
            }
            adventureCategoryName
            adventureParentSupplies {
              item
            }
            adventureSitterSupplies {
              item
            }
            ageRangeText
            ageRanges {
              minRange
              maxRange
              optionText
              id
            }
            description
            draftedAt
            duration
            maxPayRate
            minPayRate
            sitterAvailability {
              monday
              tuesday
              wednesday
              thursday
              friday
              saturday
              sunday
            }
            status
            surcharge
            title
            sitterLocation {
              cityname
              stateabbr
            }
            sitterPassion
            draftedAt
            updatedAt
          }
        }
      }
      totalCount
    }
  }
`;

export const SITTER_PROFILE_QUERY = gql`
  query {
    sitterProfile {
      firstName
      lastInitial
      location {
        cityname
        stateabbr
      }
      distanceWillingToTravel
      minPayRate
      maxPayRate
      hasActiveBackgroundCheck
      isFeaturedSitter
      hasPremiumSubscription
      sitterAvailability {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
  }
`;

export const ADVENTURE_SEARCH_QUERY = gql`
  query ($searchParams: AdventureSearchInput!, $first: Int, $after: String) {
    adventureSearch(searchParams: $searchParams, first: $first, after: $after) {
      ... on AdventureSearchResultConnection {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            adventure {
              id
              adventureCategoryImage {
                url
              }
              title
              sitterFirstName
              sitterLastInitial
              ageRangeText
              adventureCategoryName
              sitterImageUrl
              minPayRate
              maxPayRate
              sitterLocation {
                stateabbr
                cityname
              }
            }
          }
        }
      }
    }
  }
`;

export const ADVENTURE_DETAILS_QUERY = gql`
  query ($id: Int!) {
    adventureDetails(id: $id) {
      adventure {
        adventureCategoryId
        adventureCategoryImage {
          id
          url
        }
        adventureCategoryName
        adventureParentSupplies {
          item
        }
        adventureSitterSupplies {
          item
        }
        ageRangeText
        ageRanges {
          minRange
          maxRange
          optionText
          id
        }
        description
        duration
        id
        maxPayRate
        minPayRate
        sitterAvailability {
          sunday
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
        }
        sitterFirstName
        sitterLastInitial
        sitterId
        sitterImageUrl
        title
        sitterLocation {
          stateabbr
          cityname
        }
        sitterMilesWillingToTravel
        surcharge
        sitterPassion
        sitterYearsExperience
        sitterUuid
        status
      }
    }
  }
`;

export const SITTER_RATING_QUERY = gql`
  query ($ids: [UUID!]!) {
    sitters(ids: $ids) {
      totalRatings
      avgRating
    }
  }
`;
